<template>
  <header class="c-header-desktop">
    <CurrentStep
      :current="data.currentNumberQuestion + 1"
      :max="data.questionDetails.total_questions"
    />
    <div class="spacer"></div>
    <BulletList :bullets="data.bullets" />
    <div class="spacer"></div>
    <CoinsCount :coins="data.collectedPoints" />
  </header>
</template>

<script>
import BulletList from "../common/BulletList";
import CurrentStep from "../common/CurrentStep";
import CoinsCount from "../common/CoinsCount";

export default {
  name: "QuizQuestionDesktopHeader",
  props: ["data"],
  components: { BulletList, CurrentStep, CoinsCount }
};
</script>

<style lang="scss" scoped>
.c-header-desktop {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 50px;
  @media (min-width: 992px) {
    margin-bottom: 80px;
  }
}

.spacer {
  flex-grow: 1;
  position: relative;

  &:after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    height: 2px;
    width: 70%;
    transform: translate(-50%, -50%);
    background-color: #dde0fa;
  }
}
</style>
